import {EntryScope} from 'shared';

export const getTopLevelEntryScopes = () => {
    return [EntryScope.Dash];
};
